<script>
import AttachmentListItem from '@components/attachment-list-item.vue'
import store from '@state/store'
export default {
  components: {
    AttachmentListItem,
  },
  props: {
    attachments: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isIntersecting: false,
      isScrolling: false,
      programmatic: false,
    }
  },
  computed: {
    highlight() {
      return store.getters['animations/getHighlightAttachments']
    },
  },
  beforeDestroy() {
    store.dispatch('animations/setHighlightAttachments', false)
  },
  methods: {
    deleteAttachment(id) {
      this.$emit('delete-attachment', id)
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      this.isScrolling = true
    },
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<template>
  <v-list
    id="#attachments"
    v-scroll:#componentArea="onScroll"
    v-intersect.once="onIntersect"
    :class="isIntersecting && isScrolling && highlight ? 'targetHighlight' : ''"
    class="attachmentList"
    color="offwhite"
    :disabled="disabled"
  >
    <AttachmentListItem
      v-for="item in attachments"
      :key="'attachment-' + item.id"
      :disabled="disabled"
      :item="item"
      :attachments="attachments"
      @delete-attachment="deleteAttachment"
    />
  </v-list>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style lang="scss" scoped>
@import '@design';

.targetHighlight {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 1s linear;
}

/* also need keyframes and -moz-keyframes */
@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
